import { lazyLoad } from "../../../../utils/loadable.js";

export const Dashboard = lazyLoad(
    () => import("./index.js"),
    (module) => module.Dashboard,
);
